import { render } from "./DsButton.vue?vue&type=template&id=52f7eade&scoped=true"
import script from "./DsButton.vue?vue&type=script&lang=js"
export * from "./DsButton.vue?vue&type=script&lang=js"

import "./DsButton.vue?vue&type=style&index=0&id=52f7eade&scoped=true&lang=scss"
import "./DsButton.vue?vue&type=style&index=1&id=52f7eade&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52f7eade"]])

export default __exports__